import React, { useEffect } from 'react'
import { counters } from '../../utility/counters'
import { Fade } from 'react-awesome-reveal'

function Counters() {

    useEffect(() => {
        const updateCounters = () => {
            const counters = document.querySelectorAll('.count');

            counters.forEach(counter => {
                const target = +counter.getAttribute('data-target');
                const count = +counter.innerText;

                const increment = target / 200;

                if (count < target) {
                    counter.innerText = Math.ceil(count + increment);
                } else {
                    counter.innerText = target;
                }
            });
        };

        const animationInterval = setInterval(updateCounters, 20);

        return () => clearInterval(animationInterval);
    }, []);


    return (
        <section className="section-counters padding-tb-100 bg-market">
            <div className="container">
                <div className="row">
                    <Fade triggerOnce duration={800} direction='up' className="col-lg-3 col-sm-6 col-12 counters">
                        {
                            counters.map((data, index) => (
                                <div key={index} className="zx-counters">
                                    <div className="zx-element-counters">
                                        <h2>
                                            <span data-target={data.number} className="count">{0}</span>
                                            <span>+</span>
                                        </h2>
                                        <p>{data.name}</p>
                                    </div>
                                </div>
                            ))
                        }
                    </Fade>
                </div>
            </div>
        </section>
    )
}

export default Counters
